import Component from '@glimmer/component';

import CAtom from 'rise-ui/components/c-atom.gjs';
import string from 'rise-ui/helpers/string.js';

export default class TimeSeriesSearchHelpComponent extends Component {
  <template>
    <div class="c-help" ...attributes>
      <p class="c-help__primary">
        Use the search and filters below to select locations at which to query and
        output time series data.
      </p>
      <ol class="c-help__list">
        <li class="c-oli c-oli--1">
          Narrow the list of locations using one or more of the following methods.
          <ol>
            <li class="c-oli c-oli--2">
              SEARCH: Enter search terms into the search bar and submit
              <CAtom>(<span class="c-search-button c-search-button--example c-search-button--refresh"></span>)</CAtom>
              the search.
            </li>
            <li class="c-oli c-oli--2">
              FILTERS: Choose <CAtom>(<input
                type="checkbox"
                checked="checked"
                aria-label="Example Filter Option Checkbox"
              >)</CAtom>
              and apply
              <CAtom>(<span class="c-search-button c-search-button--example c-search-button--filter c-search-button--refresh"></span>)</CAtom>
              filters.
            </li>
          </ol>
        </li>
        <li class="c-oli c-oli--1">
          Add <CAtom>(<span class="c-add-button c-add-button--example c-add-button--add-context"></span>)</CAtom>
          the desired location(s) to your selection. A maximum of 100 locations may be selected.
        </li>
        <li class="c-oli c-oli--1">
          Clear or adjust the search and filters to make additional locations selections.
        </li>
        <li class="c-oli c-oli--1">
          Move on to "{{string "time-series-search-route"}}" to select time series and set date ranges.
        </li>
      </ol>
      {{yield}}
    </div>
  </template>
}
